import cn from 'clsx'
import React from 'react'
import { DropTarget } from 'react-dnd'
import {
  uploadFilesToBrowse,
  uploadFilesToGroups,
} from '@disco/state-management/actions/upload-actions'
import { TRACK_NESTING } from '@disco/constants/FeatureTypes'
import { CUSTOM_CHANNEL, TEAM_LIBRARY } from '@disco/constants/GroupTypes'
import { FILE } from '@disco/constants/ItemTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { useGroupLocks } from '@disco/state-management/selectors/groups'
import { getFilesFromDraggedItem } from '@disco/utils/file-utils'
import { DropFilesIndicator } from 'components/ui/drop-indicator'
const explorerTarget = {
  canDrop(props, monitor) {
    const item = monitor.getItem()
    const { library } = props
    if (library?.permissions && !library.permissions.content) return false
    return Boolean(item.files)
  },

  drop({ uploadFilesToBrowse, uploadFilesToGroups, library }, monitor) {
    const draggedItem = monitor.getItem()
    // don't handle drop if child already handle it
    if (monitor.didDrop()) return

    if (draggedItem.items) {
      getFilesFromDraggedItem(draggedItem).then((files: File[]) => {
        if (files.length > 0) {
          if (library?.group_type === TEAM_LIBRARY) {
            uploadFilesToBrowse(files)
          } else if (library?.group_type === CUSTOM_CHANNEL) {
            uploadFilesToGroups(files, [library])
          }
        }
      })
    }
  },
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({
      shallow: true,
    }),
    canDrop: monitor.canDrop(),
  }
}

type Props = {
  isOver: boolean
  canDrop: boolean
  connectDropTarget: (...args: Array<any>) => any
  children: React.ReactNode
  library: Record<string, any> | null | undefined
  uploadFilesToBrowse: typeof uploadFilesToBrowse
  uploadFilesToGroups: typeof uploadFilesToGroups
}

const ExplorerDropWrapper = ({
  isOver,
  connectDropTarget,
  canDrop,
  children,
  library,
}: Props) => {
  const featureEnabled = useFeatureEnabled(TRACK_NESTING)
  const restrictions = useGroupLocks(library?.id)
  if (!featureEnabled || restrictions?.lock_content) return children
  if (
    library?.group_type !== CUSTOM_CHANNEL &&
    library?.group_type !== TEAM_LIBRARY
  )
    return children
  const dropTargetClass = cn({
    HighlightedDropTarget: isOver && canDrop,
  })
  return connectDropTarget(
    <div className={dropTargetClass}>
      {children}
      {isOver && canDrop && <DropFilesIndicator />}
    </div>,
  )
}

export default DropTarget(
  [FILE],
  explorerTarget,
  collect,
)(ExplorerDropWrapper) as any
